// Port of api/fuel/app/classes/filter/search/games/rules/query/official_count.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'official_count',
	isRange: function() { return true },
	fieldLow: function() { return 'g.game_players_min' },
	fieldHigh: function() { return 'g.game_players_max' }
})
